module.exports.PAGE = {
  PRICING_DETAILS: 'pricing_details',
  SLOTTED_DETAILS: 'slotted_details',
  SURVEY_SEARCH: 'survey_search',
  SLOTTED_SEARCH: 'slotted_search',
  JOB_SEARCH: 'job_search',
  DASHBOARD: 'dashboard',
  REVIEW_IMPACT: 'geo_differential',
  JOB_EMPLOYEES: 'employees',
  JOB_DETAILS: 'job_details',
  BULK_PRICING_SURVEY_SEARCH: 'bulk_pricing_survey_search',
  BULK_PRICING_ORG_JOBS: 'bulk_pricing_org_jobs',
  BULK_PRICING_PRICE: 'bulk_pricing_price'
};

module.exports.PAGE_CODE = {
  PRICING_DETAILS: 'price3',
  SLOTTED_DETAILS: 'slot_job',
  SURVEY_SEARCH: 'search_matches',
  SLOTTED_SEARCH: 'price',
  JOB_SEARCH: 'price',
  REVIEW_IMPACT: 'geo_differential',
  JOB_EMPLOYEES: 'employees',
  JOB_DETAILS: 'topview',
  BULK_PRICING_SURVEY_SEARCH: 'bulk_pricing_survey_search',
  BULK_PRICING_ORG_JOBS: 'bulk_pricing_org_jobs',
  BULK_PRICING_PRICE: 'bulk_pricing_price'
};

module.exports.CATEGORY_CODE = {
  PRICING_DETAILS: 'mp_details_job_view',
  SLOTTED_DETAILS: 'mp_slotted_jobs',
  SURVEY_SEARCH: 'survey_jobs',
  SLOTTED_SEARCH: 'jobs',
  JOB_SEARCH: 'jobs',
  REVIEW_IMPACT: 'geo_differential',
  JOB_EMPLOYEES: 'employees',
  JOB_DETAILS: 'jobs',
  BULK_PRICING_SURVEY_SEARCH: 'survey_jobs',
  BULK_PRICING_ORG_JOBS: 'jobs',
  BULK_PRICING_PRICE: 'pricing_grid_configuration'
};
